import React from "react";
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LineChart,
    Line,
} from "recharts";

const CustomLineChartChart = ({ data,lineType, Linedatakey, XAxisDataKey, name }) => {
    return (
        <ResponsiveContainer width="100%" height={400}>
            <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey={XAxisDataKey} />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type={lineType || "monotone"} dataKey={Linedatakey} stroke="#8884d8" name={name} />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default CustomLineChartChart;
